import React from 'react';
import { useTranslation } from 'react-i18next';

import { Field } from 'formik';

import './style.scss';

const WebformSearch = ({ ...fieldProps }) => {
  const title = fieldProps.entity.get('#title');
  const webformKey = fieldProps.entity.get('#webform_key');
  const required = fieldProps.entity.get('#required');
  const requiredError = fieldProps.entity.get('#required_error');
  const placeholder = fieldProps.entity.get('#placeholder');
  const { t } = useTranslation();

  const validation = (value) => {
    let error;
    if (required && !value) {
      error = requiredError || t('webform.required');
    }
    return error;
  };

  return (
    <div className="WebformSearchField">
      <div className="FormElement SearchField">
        <label htmlFor={webformKey}>{title}</label>
        <Field
          name={webformKey}
          type="search"
          value={fieldProps.values[webformKey]}
          placeholder={placeholder}
          validate={validation}
        />
        <i className="icon-after icon-search" />
        <span className="SearchField__search-text">ZOEK</span>
        { fieldProps.errors[webformKey] && fieldProps.touched[webformKey] ? <div className="SearchField__error FormElement__error">{fieldProps.errors[webformKey]}</div> : null}
      </div>
    </div>
  );
};

export default WebformSearch;
